import { equals, includes, pathEq, pathOr, pick } from 'ramda';
import { ProjectStatusEnum } from '@fasstech/oip-core/entities/enums';
import { offerCodeEnum } from '@@viewEnums';

const useExtraSimulationRecapForm = ({ getMiddleBoolean, projectStatus, form }) => {
  const formValues = form.getValues();
  const signatureAdvice = getMiddleBoolean(
    'PROCESSDEVENTE_SIGNATURE_SYNTHESE_ELECTRONIQUE_DISPONIBLE'
  );

  const isAdviceSignatureSentForSignature = equals(projectStatus, 'ADVICE_SENT_FOR_SIGNATURE');
  const isAdviceSignatureError = includes(projectStatus, [
    'ADVICE_SIGNATURE_REFUSED',
    'ADVICE_SIGNATURE_EXPIRED'
  ]);
  const isAdviceSignatureSigned = includes(projectStatus, [
    'ADVICE_SIGNED',
    ProjectStatusEnum.EDITING
  ]);

  const isDutyOfAdviceSkipped = pathEq(
    ['offer', 'code'],
    offerCodeEnum.INDIVIDUAL_PROTECTION_DAILY_BENEFIT,
    formValues
  )
    ? pathOr(false, ['collectionNeeds', 0, 'isDutyOfAdviceSkipped'], formValues)
    : true;

  const data = pick(['commission'], formValues);

  return {
    signatureAdvice,
    isAdviceSignatureSentForSignature,
    isAdviceSignatureError,
    isAdviceSignatureSigned,
    isDutyOfAdviceSkipped,
    data
  };
};

export default useExtraSimulationRecapForm;
